const routers = [
    {
    // 供求列表
    path: '/account/index',
    name: 'account_index',
    component: () => import('./Index.vue')
  }
]
export default routers